if (!customElements.get('hoculus-cookie-preferences')) {
    class HoculusCookiePreferences extends HTMLElement {
        preferences = ["analytics", "marketing", "sale_of_data", "preferences"];
        currentConsent = {};
        preferenceCheckboxes = this.querySelectorAll('input.cookie-preference');

        constructor() {
            super();
            this.cookieBanner = document.querySelector("#" + this.dataset.banner)
            this.acceptAllButton = this.querySelector(".accept-all-cookies");
            this.savePreferencesButton = this.querySelector(".accept-selected-cookies");
            this.rejectAllButton = this.querySelector(".manage-cookies");
        }

        connectedCallback() {
            window.Shopify.loadFeatures(
                [
                    {
                        name: 'consent-tracking-api',
                        version: '0.1',
                    }
                ],
                error => {
                    if (error) {
                        console.error('Error loading Shopify features: ', error);
                    }else {
                        this.init();
                    }
                },
            );
        }

        init(){
            this.readVisitorConsent();

            this.restoreCookiePreferences();

            this.addEventListener('modal:open', this.openPopup)

            this.addEventListener('click', (evt) => {
                if (evt.target === evt.currentTarget) {
                    this.closePopup(false);
                }
            })

            this.acceptAllButton.addEventListener('click', () => {
                this.acceptAllCookies();
                this.closePopup();
            })

            this.savePreferencesButton.addEventListener('click', () => {
                this.savePreferencesCookies();
                this.closePopup();
            })

            this.rejectAllButton.addEventListener('click', () => {
                this.rejectAllCookies();
                this.closePopup();
            })
        }

        openPopup() {
            this.classList.remove("d-none");
        }

        setCookiePreferences() {
            window.Shopify.customerPrivacy.setTrackingConsent(this.currentConsent);
        }

        readVisitorConsent() {
            const browserConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
            for (const preference of this.preferences) {
                // Since the customerPrivacy api returns values of 'yes' and 'no' we have to turn them into true and false or null if empty
                browserConsent[preference] = 'yes' ? this.currentConsent[preference] = true : this.currentConsent[preference] = false;
                switch (window.Shopify.customerPrivacy.currentVisitorConsent()[preference]) {
                    case 'yes':
                        this.currentConsent[preference] = true
                        break;
                    case 'no':
                        this.currentConsent[preference] = false
                        break;
                    default:
                        this.currentConsent[preference] = null
                        break;
                }
            }
        }

        // Restores the cookies and sets them
        restoreCookiePreferences() {
            this.readVisitorConsent();

            // Remove duplicate values from currentConsent array (ex. true, true, false, null => true, false, null)
            const uniqueConsentValues = Array.from(new Set(Object.values(this.currentConsent)))
            
            // If there's only one value and it's null it means cookies have not been set yet, therefore show the banner
            if (uniqueConsentValues.length == 1 && uniqueConsentValues[0] === null) {
                this.cookieBanner.openBanner();
            } else {
                this.updateCheckboxes();
            }
        }

        acceptAllCookies() {
            for (const preference of this.preferences) {
                this.currentConsent[preference] = true;
            }
            this.setCookiePreferences();
            this.updateCheckboxes();
        }

        rejectAllCookies() {
            for (const preference of this.preferences) {
                this.currentConsent[preference] = false;
            }
            this.setCookiePreferences();
            this.updateCheckboxes();
        }

        savePreferencesCookies() {
            for (const checkbox of this.preferenceCheckboxes) {
                this.currentConsent[checkbox.name] = checkbox.checked;
            }

            this.setCookiePreferences();
        }

        closePopup(closeBanner = true) {
            this.classList.add('d-none');
            if (closeBanner) this.cookieBanner.closeBanner();
        }

        updateCheckboxes() {
            for (const checkbox of this.preferenceCheckboxes) {
                checkbox.checked = this.currentConsent[checkbox.name];
            }
        }
    }

    customElements.define("hoculus-cookie-preferences", HoculusCookiePreferences);
}